export enum AmountType {
  SINGLE = 'SINGLE',
  RANGE = 'RANGE',
}
